// @ts-check
const TaskFilterSidebar = ({ filters, onFilterChange, onReset, adminUsers = [] }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-4 space-y-6">
      {/* Header */}
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h3 className="font-semibold text-foreground">Filters</h3>
        <button
          onClick={onReset}
          className="text-sm text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300"
        >
          Reset All
        </button>
      </div>

      {/* Search */}
      <div>
        <label className="block text-sm font-medium text-foreground/80 mb-2">Search</label>
        <input
          type="text"
          value={filters.search || ''}
          onChange={(e) => onFilterChange('search', e.target.value || null)}
          placeholder="Search tasks..."
          className="w-full px-3 py-2 border border-input rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        />
      </div>

      {/* Assigned To */}
      <div>
        <label className="block text-sm font-medium text-foreground/80 mb-2">Assigned To</label>
        <select
          value={filters.assigned_to || ''}
          onChange={(e) => onFilterChange('assigned_to', e.target.value || null)}
          className="w-full px-3 py-2 border border-input rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="">All</option>
          {adminUsers.map((user) => (
            <option key={user.id} value={user.id}>
              {user.full_name}
            </option>
          ))}
        </select>
      </div>

      {/* Status */}
      <div>
        <label className="block text-sm font-medium text-foreground/80 mb-2">Status</label>
        <select
          value={filters.status || ''}
          onChange={(e) => onFilterChange('status', e.target.value || null)}
          className="w-full px-3 py-2 border border-input rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="">All Statuses</option>
          <option value="to_do">To Do</option>
          <option value="in_progress">In Progress</option>
          <option value="review">Review</option>
          <option value="done">Done</option>
          <option value="blocked">Blocked</option>
        </select>
      </div>

      {/* Priority */}
      <div>
        <label className="block text-sm font-medium text-foreground/80 mb-2">Priority</label>
        <select
          value={filters.priority || ''}
          onChange={(e) => onFilterChange('priority', e.target.value || null)}
          className="w-full px-3 py-2 border border-input rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="">All Priorities</option>
          <option value="low">Low</option>
          <option value="medium">Medium</option>
          <option value="high">High</option>
          <option value="urgent">Urgent</option>
        </select>
      </div>

      {/* Due Date Range */}
      <div>
        <label className="block text-sm font-medium text-foreground/80 mb-2">Due Date</label>
        <div className="space-y-2">
          <input
            type="date"
            value={filters.due_date_from || ''}
            onChange={(e) => onFilterChange('due_date_from', e.target.value || null)}
            placeholder="From"
            className="w-full px-3 py-2 border border-input rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
          <input
            type="date"
            value={filters.due_date_to || ''}
            onChange={(e) => onFilterChange('due_date_to', e.target.value || null)}
            placeholder="To"
            className="w-full px-3 py-2 border border-input rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      </div>

      {/* Tags */}
      <div>
        <label className="block text-sm font-medium text-foreground/80 mb-2">Tags</label>
        <input
          type="text"
          value={filters.tags || ''}
          onChange={(e) => onFilterChange('tags', e.target.value || null)}
          placeholder="Comma-separated"
          className="w-full px-3 py-2 border border-input rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        />
      </div>

      {/* Include Deleted */}
      <div className="flex items-center">
        <input
          type="checkbox"
          id="include_deleted"
          checked={filters.include_deleted || false}
          onChange={(e) => onFilterChange('include_deleted', e.target.checked || false)}
          className="h-4 w-4 text-blue-600 dark:text-blue-400 border-input rounded-md focus:ring-blue-500"
        />
        <label htmlFor="include_deleted" className="ml-2 text-sm text-foreground/80">
          Include deleted tasks
        </label>
      </div>
    </div>
  );
};

export default TaskFilterSidebar;
